import { DeleteEvent, GetEvent, PatchEvent, SubmitEvent } from '~/machines/base-crud';
import { MalpracticeClaim } from '~/types';
import { deleteData, getData, patchData, postData } from '~/utils/service';
import { ClaimsContext, MalpracticeClaimFormValues } from './types';
import { claimApiToForm, claimFormToApi, claimsApiToForm } from './utils';

const ROUTE_NAME = 'claims';
interface ClaimsInput<T> {
  input: {
    context: ClaimsContext;
    event: T;
  };
}

export const CLAIMS_ROUTES = {
  get: '/malpractice-claim',
  post: '/malpractice-claim',
  patch: '/malpractice-claim/{id}',
  delete: '/malpractice-claim/{id}',
};

export const API_CALLS = {
  get: async ({ input }: ClaimsInput<GetEvent>): Promise<MalpracticeClaim[]> => {
    return await getData(ROUTE_NAME, {
      sort: input.context.sort,
      transformResponse: claimsApiToForm,
    });
  },
  create: async ({
    input,
  }: ClaimsInput<SubmitEvent<MalpracticeClaimFormValues>>): Promise<MalpracticeClaim> => {
    return await postData(ROUTE_NAME, {
      data: input.event.values,
      transformRequest: claimFormToApi,
      transformResponse: claimApiToForm,
    });
  },
  delete: async ({ input }: ClaimsInput<DeleteEvent>) => {
    return await deleteData(ROUTE_NAME, {
      pathParams: { id: input.event.payload.id.toString() },
    });
  },
  patch: async ({
    input,
  }: ClaimsInput<PatchEvent<MalpracticeClaimFormValues>>): Promise<MalpracticeClaim> => {
    return await patchData(ROUTE_NAME, {
      pathParams: { id: input.event.values.id?.toString() || '' },
      data: input.event.values,
      transformRequest: claimFormToApi,
      transformResponse: claimApiToForm,
    });
  },
};
